export default {
	html: 'http://www.w3.org/1999/xhtml',
	svg: 'http://www.w3.org/2000/svg',
	mathML: 'http://www.w3.org/1998/Math/MathML',
	xmlns: 'http://www.w3.org/2000/xmlns/'
};
